// Type declaration for the SEAP window functions

type SEAPWindow = {
    setUserId: (userId: string) => Promise<void>;
    setUserAuthenticated: (authenticated: boolean) => Promise<void>;
    closeToken: () => Promise<string>;
  }

  declare global {
    interface Window {
      seapweb: SEAPWindow;
    }
  }

  /**
   * Set the user id for the SEAP session
   * @param userId - The user id to set
   */
  export const setUserId = async (userId: string): Promise<void> => {
    try {
      if (!isOperationAvailable('setUserId')) {
        return;
      }

      return await window.seapweb.setUserId(userId);
    } catch (error) {
      // SEAP operation failed silently
    }
  };

  /**
   * Set the user authenticated for the SEAP session
   * @param authenticated - The authenticated status to set
   */
  export const setUserAuthenticated = async (authenticated: boolean): Promise<void> => {
    try {
      if (!isOperationAvailable('setUserAuthenticated')) {
        return;
      }

      return await window.seapweb.setUserAuthenticated(authenticated);
    } catch (error) {
      // SEAP operation failed silently
    }
  };

  /**
   * Get the SEAP token
   * @returns Promise with the result of the SEAP operation
   */
  export const closeToken = async (): Promise<string> => {
    try {
      if (!isOperationAvailable('closeToken')) {
        return '';
      }

      return await window.seapweb.closeToken();
    } catch (error) {
      return '';
    }
  };

  const isOperationAvailable = (operation: keyof SEAPWindow): boolean => {
    return window.seapweb?.[operation] !== undefined;
  };



